module.exports = __webpack_public_path__ + "images/category_lp/home_appliance/store_images/3_6520b5effa677a7ce67701da879a4daf.png";